import { isAndroid } from '@/infrastructure/product-info';
import { ApiInfo } from '@/presentation/hooks/compliance/api';


/**
 * 获取api信息
 */
export const getApiInfo = (apiInfos?: ApiInfo[], privacyType?: string | null, privacyFunc?: string | null) => (
  apiInfos?.find((apiInfo) => {
    const api = isAndroid() ? apiInfo.shortName : apiInfo.api;
    const apiMatch = api === privacyFunc;
    const typeMatch = privacyType ? apiInfo.module === privacyType : true;
    return apiMatch && typeMatch;
  })
);

/**
 * 获取api类型
 */
export const getApiInfoType = (apiInfos?: ApiInfo[], privacyType?: string | null) => {
  const apiInfo = apiInfos?.find(apiInfo => apiInfo.module === privacyType);
  return `${apiInfo?.description || privacyType} (${privacyType})`;
};
